import { useState, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import EroticPage from './pages/EroticPage';
import NuruPage from './pages/NuruPage';
import ContactPage from './pages/ContactPage';
import { content } from './data/content';

function detectLangFromPath(pathname) {
  if (pathname.startsWith('/ko')) return 'ko';
  if (pathname.startsWith('/zh')) return 'zh';
  return 'en';
}

function detectBrowserLang() {
  const languages = navigator.languages || [navigator.language || 'en'];
  for (const lang of languages) {
    const code = lang.toLowerCase();
    if (code.startsWith('ko')) return 'ko';
    if (code.startsWith('zh')) return 'zh';
  }
  return 'en';
}

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [lang, setLang] = useState(() => detectLangFromPath(window.location.pathname));
  const [hasAutoRedirected, setHasAutoRedirected] = useState(false);

  useEffect(() => {
    const pathLang = detectLangFromPath(location.pathname);
    if (pathLang !== lang) {
      setLang(pathLang);
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (hasAutoRedirected) return;
    const isRootPath = location.pathname === '/';
    if (!isRootPath) {
      setHasAutoRedirected(true);
      return;
    }
    const userManuallyChose = sessionStorage.getItem('lang_chosen');
    if (userManuallyChose) {
      setHasAutoRedirected(true);
      return;
    }

    const browserLang = detectBrowserLang();
    setHasAutoRedirected(true);

    if (browserLang === 'ko') {
      navigate('/ko', { replace: true });
    } else if (browserLang === 'zh') {
      navigate('/zh', { replace: true });
    }
  }, []);

  const handleSetLang = (newLang) => {
    sessionStorage.setItem('lang_chosen', 'true');
    setLang(newLang);
  };

  const t = content[lang];

  return (
    <div className="min-h-screen bg-dark text-white">
      <Navbar t={t} lang={lang} setLang={handleSetLang} />
      <Routes>
        <Route path="/" element={<HomePage t={t.home} lang={lang} />} />
        <Route path="/erotic-massage-sukhumvit" element={<EroticPage t={t.erotic} lang={lang} />} />
        <Route path="/nuru-massage-sukhumvit" element={<NuruPage t={t.nuru} lang={lang} />} />
        <Route path="/zh" element={<HomePage t={content.zh.home} lang="zh" />} />
        <Route path="/zh/erotic-massage-sukhumvit" element={<EroticPage t={content.zh.erotic} lang="zh" />} />
        <Route path="/zh/nuru-massage-sukhumvit" element={<NuruPage t={content.zh.nuru} lang="zh" />} />
        <Route path="/ko" element={<HomePage t={content.ko.home} lang="ko" />} />
        <Route path="/ko/erotic-massage-sukhumvit" element={<EroticPage t={content.ko.erotic} lang="ko" />} />
        <Route path="/ko/nuru-massage-sukhumvit" element={<NuruPage t={content.ko.nuru} lang="ko" />} />
        <Route path="/contact" element={<ContactPage lang="en" />} />
        <Route path="/zh/contact" element={<ContactPage lang="zh" />} />
        <Route path="/ko/contact" element={<ContactPage lang="ko" />} />
      </Routes>
      <Footer t={t.footer} nav={t.nav} lang={lang} />
    </div>
  );
}

export default App;
